import { SvgIcon } from '@material-ui/core'
import React from 'react'

export default function StatusErrorIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 30 30" fill="none" {...props}>
            <path
                d="M28 15.5C28 22.4036 22.4036 28 15.5 28C8.59644 28 3 22.4036 3 15.5C3 8.59644 8.59644 3 15.5 3C22.4036 3 28 8.59644 28 15.5Z"
                fill="#C33E36"
            />
            <path
                d="M13.7321 15.1302L9.43102 19.4313L11.1988 21.199L15.4999 16.898L19.8009 21.199L21.5687 19.4313L17.2676 15.1302L21.5685 10.8293L19.8008 9.06152L15.4999 13.3624L11.1989 9.06151L9.43115 10.8293L13.7321 15.1302Z"
                fill="white"
            />
        </SvgIcon>
    )
}
